import * as React from 'react';
import { useCallback, useEffect, useMemo, useState } from 'react';
import dayjs from 'dayjs';
import classNames from 'classnames';
import isFunction from 'lodash/isFunction';
import { CnCalendar } from '@/components/cn-calendar';
import { SelectDrawer } from '@/components/cn-select/select-drawer';
import { toDate } from '@/utils/date';
import { formatValue, getValueFromDayjs } from './util';
import { useLatest } from 'ahooks';
function getInitValue(initValue) {
    return Array.isArray(initValue)
        ? initValue.map((i) => i || toDate(i))
        : undefined;
}
export const CnRangeDatePickerPro = (props) => {
    const { hasClear, value: valueProp, align: alignProp, size: sizeProp, iconType, placeholder, disabled, readOnly, insideForm, className, zIndex, format, outputFormat, defaultValue, onChange, onCancel, onClear, extraFooterRender, ...others } = props;
    const [value, setValue] = useState(getInitValue(valueProp || defaultValue));
    const [pickerValue, setPickerValue] = useState(defaultValue);
    const ouputFormatRef = useLatest(outputFormat);
    const align = alignProp || 'left';
    const size = sizeProp || 'medium';
    const isControlled = 'value' in props;
    useEffect(() => {
        if (isControlled) {
            const newValue = getInitValue(valueProp || defaultValue);
            if (!newValue || (Array.isArray(newValue) && newValue.every((i) => !i))) {
                setPickerValue(null);
                setValue(undefined);
                return;
            }
            else if (newValue === value) {
                return;
            }
            setValue(newValue);
            setPickerValue(newValue);
        }
    }, [valueProp, isControlled]);
    const handleCancel = (reason) => {
        setPickerValue(value);
        if (isFunction(onCancel)) {
            onCancel(reason);
        }
    };
    const handleClear = () => {
        if (!isControlled) {
            setPickerValue(null);
            setValue(undefined);
        }
        if (isFunction(onClear)) {
            onClear();
        }
        if (onChange) {
            onChange([undefined, undefined], ['', '']);
        }
    };
    const getFormated = useCallback((newValue) => {
        if (!Array.isArray(newValue))
            return undefined;
        return newValue.map((i) => {
            return dayjs(i).format(format);
        });
    }, [format]);
    const handleOk = useCallback(() => {
        const newValue = pickerValue;
        if (!newValue)
            return;
        const dayjsValue = newValue.map((i) => dayjs(i));
        const v = ouputFormatRef?.current
            ? formatValue(dayjsValue, ouputFormatRef?.current)
            : getValueFromDayjs(dayjsValue, true, props.endOfDay);
        onChange?.(v, getFormated(newValue));
        if (!isControlled) {
            setValue(newValue);
        }
    }, [pickerValue, getFormated, props.endOfDay, ouputFormatRef]);
    const content = useMemo(() => {
        const formatted = getFormated(value);
        return Array.isArray(formatted) ? formatted.join(' - ') : null;
    }, [value, getFormated]);
    if (readOnly) {
        return (React.createElement("span", { className: "cn-ui-m-date-range-picker-pro-preview" }, content));
    }
    return (React.createElement(SelectDrawer, { disableScroll: true, hasClear: hasClear, content: content, align: align, size: size, iconType: iconType, placeholder: placeholder, disabled: disabled, readOnly: readOnly, insideForm: insideForm, className: classNames(className, 'cn-ui-m-date-range-picker-pro'), drawerClassName: "cn-ui-m-date-range-picker-pro-drawer", zIndex: zIndex, onOk: handleOk, onCancel: handleCancel, onClear: handleClear, buttonPosition: "bottom" },
        React.createElement(CnCalendar, { ...others, selectionMode: "range", value: pickerValue, onChange: (val) => {
                setPickerValue(val);
            } }),
        extraFooterRender ? (React.createElement("div", { className: "cn-ui-m-date-picker-extra-footer" }, typeof extraFooterRender === 'function'
            ? extraFooterRender()
            : extraFooterRender)) : null));
};
CnRangeDatePickerPro.displayName = 'CnDateRangePickerPro';
CnRangeDatePickerPro.defaultProps = {
    format: 'YYYY-MM-DD',
};
